import { GAME_CATEGORIES } from '../constants'

export const slugifyCategory = (category) => category.toLowerCase()

/** Special rows that aren't a `gameCategory` filter, just a different sort/filter of the whole set. */
export const PSEUDO_SECTIONS = {
  featured: { title: 'Featured games', sort: 'new', featured: true },
  'new-games': { title: 'New games', sort: 'new' }
}

/** Resolves a /games/:category url param into { title, category?, sort } for the API call. */
export const resolveCategorySlug = (slug) => {
  if (PSEUDO_SECTIONS[slug]) return PSEUDO_SECTIONS[slug]

  const category = GAME_CATEGORIES.find((c) => slugifyCategory(c) === slug)
  if (category) return { title: category, category, sort: 'new' }

  // Unknown slug - fall back to treating it as a literal category name
  return { title: slug, category: slug, sort: 'new' }
}
